const getCampaignStatus = (campaign) =>
  campaign.is_live ? 'live' : campaign.is_expired ? 'expired' : 'inactive';

export default getCampaignStatus;
